module.exports = __webpack_public_path__ + "static/media/adminportal2.b31295f5.svg";